import {
  Box,
  Card,
  Typography,
} from '@mui/material';
import { ellipsisStyle } from '../common/utils/style.utils';
import { KheopsTypographyVariant } from '../providers/CustomThemeProvider';

export interface ContractInfoCardProps {
  imageUrl: string;
  title: string | number;
  text: string;
  containerColor: string;
  imageWidth?: number;
  imageHeight?: number;
  children?: React.ReactNode;
  titleVariant?: KheopsTypographyVariant;
}

export default function ContractInfoCard({ imageUrl, title, text, containerColor, imageWidth, imageHeight, children, titleVariant = 'titleLarge' }: ContractInfoCardProps): React.JSX.Element {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 2,
        px: 1.5,
        borderRadius: 6,
        backgroundColor: containerColor,
        flex: 1,
        overflow: 'hidden',
        justifyContent: 'center',
        width: {
          lg: 243,

        },
      }}
    >
      <Box
        component="img"
        src={imageUrl}
        sx={{
          width: imageWidth,
          height: imageHeight,
        }}
      />
      <Typography
        variant={titleVariant}
        color="primary"
        sx={{
          ...ellipsisStyle,
          width: '100%',
          textAlign: 'center',
          mt: 1.5,

          '::first-letter': {
            textTransform: 'uppercase',
          },
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="bodySmall"
        sx={{
          color: 'onSurfaceVariant.main',
        }}
      >
        {text}
      </Typography>
      {children}
    </Card>
  );
}
